import { ColumnTypes } from '@/components';
import ProgramActionButtons from '@/components/program-action-buttons';
import {
	AGRI_FRANCHISE_OPTIONS,
	AppProgramStatusEnum,
	BusinessType,
	FISHERY_FRANCHISE_OPTIONS,
	TListOption,
} from '@/constant';
import { getColumnItem, getWorkderApplicantStatus } from '@/utils';

import { isNilOrEmpty } from 'ramda-adjunct';

export const rowKey = 'franchiseId';

interface IParams {
	programId: number;
	programEndDate: string;
	callbackSuccess?: () => void;
}

const listOption = (params: IParams): TListOption[] => [
	{
		title: `ID`,
		key: 'franchiseId',
	},
	{ title: `구분`, key: 'typeName' },
	{ title: `구분 상세`, key: 'typeDetailName' },
	{ title: `고용주`, key: 'employerName' },
	{ title: `고용주 전화번호`, key: 'employerPhone' },
	{ title: `사업장 주소`, key: 'address' },
	{
		title: `작물`,
		key: 'productionTypeDetail',
	},
	{
		title: '심사',
		key: 'actions',
		className: 'w-[200px]',
		render: (value: string, record: any) => {
			return (
				<ProgramActionButtons
					status={record.status as AppProgramStatusEnum}
					franchiseId={record?.franchiseId}
					programId={params?.programId}
					callbackSuccess={params.callbackSuccess}
					programEndDate={params.programEndDate}
				/>
			);
		},
	},
	{
		title: '신청 현황',
		key: 'status',
		className: 'w-[200px]',
		render: (value: string) => {
			return getWorkderApplicantStatus({
				programEndDate: params.programEndDate,
				status: value as AppProgramStatusEnum,
			});
		},
	},
	{ title: `등록일`, key: 'registDt' },
];

export const getColumns = (params: IParams): ColumnTypes =>
	listOption(params).map((e: TListOption) => getColumnItem(e));

export const CATEGORIES = [
	{
		value: '',
		label: '구분 전체',
	},
	{
		value: BusinessType.AGRICULTURAL,
		label: '농업 전체',
	},
	...AGRI_FRANCHISE_OPTIONS,
	{
		value: BusinessType.FISHING,
		label: '어업 전체',
	},
	...FISHERY_FRANCHISE_OPTIONS,
];

export const columnsCurrentSituation = [
	{
		title: '농가',
		key: 'programFarmCnt',
		dataIndex: 'programFarmCnt',
		render: (value: number) => (isNilOrEmpty(value) ? '-' : `${value}개`),
	},
	{
		title: '농가 법인·조합',
		key: 'programAgriculturalCoCnt',
		dataIndex: 'programAgriculturalCoCnt',
		render: (value: number) => (isNilOrEmpty(value) ? '-' : `${value}개`),
	},
	{
		title: '농가 공공형',
		key: 'programPublicFranchiseCnt',
		dataIndex: 'programPublicFranchiseCnt',
		render: (value: number) => (isNilOrEmpty(value) ? '-' : `${value}개`),
	},
	{
		title: '어가',
		key: 'programFishingCnt',
		dataIndex: 'programFishingCnt',
		render: (value: number) => (isNilOrEmpty(value) ? '-' : `${value}개`),
	},
	{
		title: '어가 법인·조합',
		key: 'programCorporateFishingCnt',
		dataIndex: 'programCorporateFishingCnt',
		render: (value: number) => (isNilOrEmpty(value) ? '-' : `${value}개`),
	},
	{
		title: <span className="font-bold">총 사업장</span>,
		key: 'programFranchiseCnt',
		dataIndex: 'programFranchiseCnt',
		render: (value: number) => (isNilOrEmpty(value) ? '-' : `${value}개`),
	},
];
